import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MemoRow from './row';
import { updateGrid as updateG, updateDestination } from '../../redux/mapICCICSlice';
import { calculateErrors } from './calculateerrors';

const Grid = () => {
    const dispatch = useDispatch();
    const { services, codAmountLimit } = useSelector(state => state.appData);
    const state = useSelector(state => { return { appData: state.appData, MapICCIDData: state.MapICCIDData } });
    const { destinations, userInfo } = state.appData;
    
    const destRef = useRef(null);
    const {
        data,
        grid,
    } = state.MapICCIDData;

    const amountLimitCheck = codAmountLimit?.length > 0 && codAmountLimit?.filter(i => i.accountNo.toUpperCase() == data.accountNo.toUpperCase());
    
    let codAmountL = 99999;
    if(amountLimitCheck.length > 0) {
        codAmountL = amountLimitCheck[0].amount;
    }

    const updateGrid = (index, key, val) => {
        dispatch(updateG({ index, key, val }));
    };

    const updateDest = (index, val) => {
        dispatch(updateDestination({ index, val, dests: destinations }));
    }

    const findDuplicates = (CustomerReferenceNumber) => {
        const arrayForSort = [...grid]
        let sorted_grid = arrayForSort.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => ({ index, CustomerReferenceNumber: x.CustomerReferenceNumber })).sort(function (a, b) {
            return ('' + a.CustomerReferenceNumber).localeCompare(b.CustomerReferenceNumber);
        });
        let results = [];
        for (let i = 0; i < sorted_grid.length - 1; i++) {
            if (sorted_grid[i + 1].CustomerReferenceNumber == sorted_grid[i].CustomerReferenceNumber) {
                results.push(sorted_grid[i]);
            }
        }
        return results.findIndex(d => d.CustomerReferenceNumber.trim().toUpperCase() == CustomerReferenceNumber.trim().toUpperCase()) !== -1;
    }

    return <div className="row mt-2">
        <div className="table-responsive" style={{ maxHeight: "450px" }}>
            <table className="table">
                <thead>
                    <tr>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Serial No</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignment No</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Customer Order Ref Number</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>ICCID</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        grid.map((x, index) => <MemoRow 
                            destRef={destRef} key={index} x={{ ...x, isCod: data.isCod }} findDuplicates={findDuplicates} formData={data} index={index} services={services} 
                            destinations={destinations} user={userInfo} autoCN={data.autoCN} updateGrid={updateGrid} updateDest={updateDest} codAmountLimit={codAmountL}
                        />)
                    }
                </tbody>
            </table>
        </div>
    </div>
}

export default Grid;
